export {globalStyles} from "./src/styles/global_styles";
export {fontFace} from "./src/styles/font_face";
export {GhThemeProvider} from "./src/styles/GhThemeProvider";
import {themeGh as theme} from "./src/themes/themeGh/theme_gh";
export const themeGh = theme;
export type IGHTheme = typeof themeGh;

import "@emotion/react";
declare module "@emotion/react" {
    export interface Theme extends IGHTheme {}
}
